import { createBucket } from '@ui-furniture/common/calculators/bucket';

import { CreateSurveyRecommendationData } from './create-recommendation-schema';

const level2CostCalculator = createBucket({
  _: 345,
  50000: 345,
  100000: 395,
  150000: 395,
  200000: 445,
  250000: 445,
  300000: 495,
  350000: 495,
  400000: 545,
  450000: 545,
  500000: 595,
  550000: 595,
  600000: 645,
  650000: 645,
  700000: 695,
  750000: 695,
  800000: 745,
  850000: 745,
  900000: 895,
  950000: 895,
});

const level3CostCalculator = createBucket({
  _: 495,
  50000: 495,
  100000: 595,
  150000: 595,
  200000: 645,
  250000: 645,
  300000: 695,
  350000: 695,
  400000: 745,
  450000: 745,
  500000: 795,
  550000: 795,
  600000: 845,
  650000: 845,
  700000: 895,
  750000: 895,
  800000: 1000,
  850000: 1000,
  900000: 1100,
  950000: 1100,
});

export const calculateSurveyPrices = (
  data: CreateSurveyRecommendationData
): {
  2: number;
  3: number;
} => {
  return {
    2: level2CostCalculator.calculate(data.price),
    3: level3CostCalculator.calculate(data.price),
  };
};
